import React from "react";

const AllAbove = ({ isOpenToAll, handleOpenToAllChange }) => {
  return (
    <div>
      <div className="edit-profile-interest-option-div">
        <div className="edit-profile-icon-wrapper intminheight">
          <div className="tabs-nav-icon w-embed">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 77 77"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_28_861)">
                <path
                  d="M35.7051 4.04799H0.852663C0.852663 4.12983 0.865295 4.21797 0.865295 4.3061V29.9602C0.865295 34.2222 0.783185 38.4906 0.877927 42.7526C0.903192 43.9361 0.966353 45.1071 1.01688 46.2655C1.30742 46.1899 1.59165 46.127 1.89482 46.0388C36.5767 36.5075 35.7051 4.04799 35.7051 4.04799Z"
                  fill="#E2B760"
                />
                <path
                  d="M2.61491 75.6528C6.4488 75.722 10.2827 75.8731 14.1166 75.9235C16.7062 75.955 19.4158 75.7031 22.0118 76.0557C21.9296 75.7535 21.8412 75.4387 21.7465 75.1177C16.6241 57.9877 4.19394 54.1474 0.852708 53.4171C0.821128 53.6438 0.795863 53.8704 0.757966 54.0971C0.663224 54.6511 0.461108 55.0854 0.189514 55.4317L1.89487 75.1177C1.89487 75.1177 2.15383 75.3191 2.61491 75.6591V75.6528Z"
                  fill="#E2B760"
                />
                <path
                  d="M75.7431 41.9845C75.4715 29.5258 75.4589 17.0607 75.4589 4.60199C75.2378 4.24315 75.1115 4.04799 75.1115 4.04799H46.032C45.7667 8.50519 44.9077 13.2016 44.7245 17.7847C48.6658 28.1849 57.1231 41.3613 75.1178 45.5289C75.3704 45.5856 75.6041 45.6296 75.8505 45.68C75.8126 44.4461 75.781 43.2185 75.7557 41.9845H75.7431Z"
                  fill="#E2B760"
                />
                <path
                  d="M76.0905 53.2534H75.1052C75.1052 53.2534 60.5149 58.5857 55.8662 75.1114C55.7904 75.3758 55.7273 75.6276 55.6704 75.8794C62.6813 75.9487 69.7175 76.4019 76.7284 76.2068C76.6779 68.5515 76.3684 60.9025 76.0905 53.2534Z"
                  fill="#E2B760"
                />
                <path
                  d="M0.94742 50.5779C0.732672 50.5779 0.517923 50.5023 0.347387 50.3638C0.126323 50.1813 0 49.9169 0 49.6336V0.944322C0 0.428093 0.423181 0 0.94742 0H39.7916C40.0569 0 40.3096 0.113319 40.4864 0.302183C40.6633 0.497343 40.758 0.755457 40.7328 1.01987C39.9559 10.5134 37.6252 19.0249 33.8166 26.3151C27.0204 39.309 16.024 47.4679 1.13059 50.5527C1.06743 50.5653 1.00427 50.5716 0.934788 50.5716L0.94742 50.5779ZM1.89484 1.88864V48.4563C14.8682 45.4597 35.6167 35.4058 38.7621 1.88864H1.89484Z"
                  fill="#000"
                />
                <path
                  d="M9.4742 21.0017C9.24682 21.0017 9.01313 20.9199 8.82996 20.7499C8.44467 20.3974 8.41941 19.7993 8.77311 19.4153C12.4238 15.468 14.4261 6.21364 14.685 0.900258C14.7103 0.377734 15.165 -0.0251769 15.6766 5.05114e-06C16.2009 0.025187 16.6051 0.46587 16.5799 0.988395C16.3272 6.20105 14.3692 16.1605 10.169 20.6932C9.97949 20.8947 9.72685 20.9954 9.4742 20.9954V21.0017Z"
                  fill="#000"
                />
                <path
                  d="M9.4742 36.8159C9.2026 36.8159 8.93101 36.6963 8.74153 36.4697C8.40677 36.0668 8.46993 35.4687 8.87417 35.1413C22.9276 23.6584 26.9952 8.44852 26.3004 1.03245C26.2499 0.51622 26.6351 0.0503549 27.1531 0.0062865C27.671 -0.0440773 28.1384 0.339947 28.1826 0.856176C28.9153 8.67516 24.7024 24.6531 10.0742 36.6019C9.89738 36.7467 9.68263 36.8159 9.4742 36.8159Z"
                  fill="#000"
                />
                <path
                  d="M25.1319 77H0.94742C0.423181 77 0 76.5782 0 76.0557V49.6336C0 49.3377 0.138955 49.0607 0.378968 48.8781C0.618981 48.7018 0.928472 48.6452 1.2127 48.727C23.2055 55.0036 26.0477 75.7346 26.073 75.9424C26.1046 76.2131 26.0225 76.4838 25.8456 76.6852C25.6625 76.8867 25.4098 77.0063 25.1382 77.0063L25.1319 77ZM1.89484 75.1114H23.995C23.1171 71.0319 18.8347 56.3508 1.89484 50.9053V75.1114Z"
                  fill="#000"
                />
                <path
                  d="M76.0526 50.578C75.9894 50.578 75.92 50.5717 75.8568 50.5591C59.4727 47.1407 47.8953 37.5842 41.4402 22.1539C41.2381 21.6755 41.4654 21.1215 41.9518 20.92C42.4318 20.7186 42.9876 20.9452 43.1898 21.43C49.2343 35.8907 59.9654 44.9751 75.1052 48.4628V1.8888H49.9354C49.4111 1.8888 48.988 1.467 48.988 0.944474C48.988 0.42195 49.4111 0.000152588 49.9354 0.000152588H76.0526C76.5768 0.000152588 77 0.42195 77 0.944474V49.6274C77 49.9107 76.8737 50.1814 76.6526 50.3577C76.4821 50.4962 76.2737 50.5717 76.0526 50.5717V50.578Z"
                  fill="#000"
                />
                <path
                  d="M67.5827 21.0017C67.3237 21.0017 67.0711 20.901 66.8816 20.6932C62.7129 16.1605 60.7676 6.20105 60.5149 0.988395C60.4897 0.46587 60.8939 0.025187 61.4181 5.05114e-06C61.9424 -0.0251769 62.3845 0.377734 62.4098 0.900258C62.6624 6.21364 64.652 15.468 68.2774 19.4153C68.6312 19.7993 68.6059 20.3974 68.2206 20.7499C68.0374 20.9136 67.8101 20.9954 67.5827 20.9954V21.0017Z"
                  fill="#000"
                />
                <path
                  d="M67.5826 36.816C67.3679 36.816 67.1595 36.7467 66.9826 36.6019C60.5023 31.2696 55.4051 24.5587 52.2471 17.193C49.7901 11.4704 48.5774 5.36375 49.0006 0.862486C49.0511 0.339962 49.5185 -0.0377671 50.0301 0.00630127C50.5543 0.0566651 50.9333 0.516235 50.8828 1.03246C50.188 8.45483 54.2303 23.6584 68.189 35.1414C68.5932 35.475 68.6501 36.0668 68.3153 36.4697C68.1258 36.6964 67.8542 36.8097 67.5826 36.8097V36.816Z"
                  fill="#000"
                />
                <path
                  d="M76.0526 77H51.8681C51.5965 77 51.3376 76.8867 51.1607 76.679C50.9839 76.4775 50.8954 76.2068 50.9333 75.9361C50.9586 75.7283 53.8009 54.9973 75.7936 48.7207C76.0779 48.6389 76.3874 48.6955 76.6274 48.8718C76.8674 49.0481 77.0063 49.3314 77.0063 49.6273V76.0494C77.0063 76.5719 76.5832 76.9937 76.0589 76.9937L76.0526 77ZM53.0114 75.1114H75.1115V50.9053C58.1716 56.3509 53.8893 71.0319 53.0114 75.1114Z"
                  fill="#000"
                />
              </g>
              <defs>
                <clipPath id="clip0_28_861">
                  <rect width={77} height={77} fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
        <label className="w-checkbox ms-pill-item">
          <input
            type="checkbox"
            name="checkbox-3"
            id="checkbox-3w"
            data-name="Checkbox 3"
            className="w-checkbox-input ms-pill-checkbox"
            checked={isOpenToAll}
            onChange={handleOpenToAllChange}
          />
          <span
            className="ms-pill-label has-icon w-form-label"
            htmlFor="checkbox-3"
          >
            All
          </span>
          <div className="ms-pill-icon w-embed">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              fill="currentColor"
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M9 16.2l-3.5-3.5c-.39-.39-1.01-.39-1.4 0-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4-.39-.39-1.01-.39-1.4 0L9 16.2z" />
            </svg>
          </div>
        </label>
      </div>
    </div>
  );
};

export default AllAbove;
